"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Html, Image } from "@custom/schema";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React, { Fragment, useState } from "react";
export default function ImageModal(props) {
    var _useState = _sliced_to_array(useState(null), 2), openModalImage = _useState[0], setOpenModalImage = _useState[1];
    var closeModal = function() {
        setOpenModalImage(null);
    };
    var openModal = function(imageData) {
        setOpenModalImage(imageData);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "mb-6"
    }, props.image ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        onClick: function() {
            var _props_image;
            return ((_props_image = props.image) === null || _props_image === void 0 ? void 0 : _props_image.source) && openModal(props.image.source);
        },
        className: clsx("", {
            "flex justify-center": props.align == "center",
            "flex justify-start": props.align == "left",
            "flex justify-end": props.align == "right"
        })
    }, /*#__PURE__*/ React.createElement(Image, {
        source: props.image.source,
        className: clsx("max-w-full cursor-pointer overflow-hidden rounded-2xl border border-gray-900 mb-0", {
            "w-[240px]": props.viewMode === "thumbnail",
            "w-[350px]": props.viewMode === "small",
            "w-[500px]": props.viewMode === "medium"
        }),
        alt: props.image.alt
    })), /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "flex justify-center": props.align == "center",
            "flex justify-start": props.align == "left",
            "flex justify-end": props.align == "right"
        })
    }, /*#__PURE__*/ React.createElement("span", {
        className: "block mt-4 font-medium leading-normal break-words format-text"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.caption
    }))), /*#__PURE__*/ React.createElement(Transition, {
        appear: true,
        show: openModalImage === props.image.source,
        as: Fragment
    }, /*#__PURE__*/ React.createElement(Dialog, {
        as: "div",
        className: "relative z-[26]",
        onClose: closeModal,
        "aria-label": "Image modal"
    }, /*#__PURE__*/ React.createElement(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 bg-black bg-opacity-75"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 overflow-y-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex min-h-full items-center justify-center p-11 text-center"
    }, /*#__PURE__*/ React.createElement(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95"
    }, /*#__PURE__*/ React.createElement(Dialog.Panel, {
        className: "w-full relative text-left align-middle transition-all"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement(Image, {
        source: props.image.source,
        className: "max-w-full mx-auto overflow-hidden rounded-2xl border border-gray-900",
        alt: props.image.alt
    })), /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: closeModal,
        className: "text-white focus:outline-none absolute -top-10 md:-top-8 right-0 md:-right-4",
        "aria-label": "Close image modal"
    }, /*#__PURE__*/ React.createElement(XMarkIcon, {
        className: "w-8 h-8"
    })))))))))) : null);
}
